export default __webpack_public_path__ + "static/media/m_diagram3.ac0e8279.png";